<template>
  <div v-if="care_vital_sign.care_has_vital_signs.length > 0">
    <p
      :class="[
        'm-0 text-thirteen upper-text',
        parseFloat(item.description) >= 1.73 &&
          parseFloat(item.description) <= 1.75 &&
          'color-green',
        parseFloat(item.description) <= 1.72 && 'color-orange',
        parseFloat(item.description) >= 1.76 && 'color-orange',
      ]"
    >
      {{ item.description }}
      {{ item.abbreviation }}
    </p>
    <p class="mb-1 worksansr text-twelve upper-text">
      CADASTRADO POR: {{ item.user_name }}
    </p>
    <hr />
  </div>
</template>

<script>
export default {
  name: "Altura",
  props: {
    care_vital_sign: Object,
    item: Object,
  },
};
</script>